// 引流投放H5接口
import request from 'umi-request'
import { apiUrl } from '../utils/url'
import { getEnv, isDevelopment } from '@/utils/utils'
import {
  ResponseData,
  IDrainageData
} from '@/projects/kiss/typings/interfaces/request'
interface bookParams {
  id: string
}

/** 新增的参数，为了兼容老数据把后续再加的数据拎出来 */
interface IDrainageExtraData {
  web_uid?: string
}

// 获取web to app引流H5详情
export const getDrainageDataByID = (
  id: string,
  extraParams: IDrainageExtraData = {}
): Promise<ResponseData<IDrainageData>> => {
  return request(`${apiUrl}/api/drainage`, {
    method: 'post',
    data: {
      id: id,
      ...extraParams
    }
  })
}

interface IAdInfo {
  /** 绑定浏览器的唯一id */
  visitorId: string
  /** h5页面链接 */
  href: string
  /** 来源链接 */
  referrer: string
  /** 传给ios的参数 */
  goto: string
}

/** 上报服务器信息（ios调用） */
export const reportAdInfo = (data: IAdInfo): Promise<any> => {
  return request(`/api/comm/apLink/send`, {
    method: 'post',
    data
  })
}

/** 获取ip接口 */
export const getIp = (): Promise<any> => {
  return request(`/api/comm/apLink/ip`, {
    method: 'post'
  })
}
